import { t } from '@lingui/core/macro'
import { useEffect, useMemo, useState } from 'react'
import Col from 'react-bootstrap/Col'
import DateRangePicker from '~/components/date_range_picker'
import MultiSelect from '~/components/multi_select'
import DashboardFilters from '~/dashboard/dashboard_filters'
import useChartFilters from '~/hooks/use_chart_filters'
import { awsAccountsChartOptionPath } from '~/routes'

export default function AWSPatchManagerFilters({ organizationId: orgId, setChartParams }) {
  const [onApply, onReset, onChange, params] = useChartFilters(setChartParams)
  const [defaultDates, setDefaultDates] = useState({ startDate: '', endDate: '' })

  // memoize URLs to prevent rerenders
  const accountsUrl = useMemo(() => awsAccountsChartOptionPath(orgId), [orgId])

  // Set default date range to last 7 days and initialize form fields like in AWS dashboard
  useEffect(() => {
    const endDate = new Date()
    const startDate = new Date()
    startDate.setDate(startDate.getDate() - 7)

    const defaultParams = {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0],
    }

    setDefaultDates(defaultParams)
    setChartParams(defaultParams)
  }, [setChartParams])

  const handleStartDateChange = (value) => {
    onChange('startDate', value)
  }

  const handleEndDateChange = (value) => {
    onChange('endDate', value)
  }

  return (
    <DashboardFilters onApply={onApply} onReset={onReset} defaultVisible buttonsOnNewLine>
      <Col>
        <MultiSelect
          label={t`Account`}
          name='awsAccountIds'
          onChange={onChange}
          url={accountsUrl}
          selected={params.awsAccountIds}
        />
      </Col>
      <Col>
        <DateRangePicker
          label={t`Date Range`}
          startDate={params.startDate || defaultDates.startDate}
          endDate={params.endDate || defaultDates.endDate}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
        />
      </Col>
    </DashboardFilters>
  )
}
